export default {
    getCpuId() {
        return localStorage.getItem("coursePlanUserId");
    },
    setCpuId(cpuId) {
        localStorage.setItem("coursePlanUserId", cpuId);
    },
    getUserId() {
        return localStorage.getItem("userId");
    },
    setUserId(userId) {
        localStorage.setItem("userId", userId);
    },
    getRealName() {
        return localStorage.getItem("realName");
    },
    setRealName(realName) {
        localStorage.setItem("realName", realName);
    },
    getCpcId() {
        return localStorage.getItem("cpcId");
    },
    setCpcId(cpcId) {
        localStorage.setItem("cpcId", cpcId);
    },
    getAccount() {
        return localStorage.getItem("account");
    },
    setAccount(account) {
        localStorage.setItem("account", account);
    },
    setClassId(classId) {
        localStorage.setItem("classId", classId)
    },
    getLocalStorage(key) {
        let cpuId = localStorage.getItem("coursePlanUserId");
        try {
            return JSON.parse(localStorage.getItem(key + cpuId));
        } catch {
            return localStorage.getItem(key + cpuId);
        }
    },
    setLocalStorage(key, content) {
        let cpuId = localStorage.getItem("coursePlanUserId");
        localStorage.setItem(key + cpuId, JSON.stringify(content));
    },
    removeLocalStorage(key) {
        let cpuId = localStorage.getItem("coursePlanUserId")
        localStorage.removeItem(key + cpuId);
    }
}